import {disPatchError} from "../utils"
import {
    ACTIVATE_DEACTIVATE_USER,
    CREATE_USER,
    GET_ALL_USERS,
    GET_USERS,
    GET_VALUES_USER_CREATE,
    RESET_ERRORS,
    UPDATE_MULTIPLE_USER,
    UPDATE_USER,
} from "../types";
import axios from "../../utils/apiClient";
import {TRACK_EVENTS, trackPendoEvent} from "../../utils/pendoTrack";

export const URL = process.env.REACT_APP_REST_API_BASE_URL + "/v1/user-admin/";


// Gets Users
export const getUsers = () => (dispatch) => {
  dispatch({ type: "TOGGLE_LOAD", payload: true });
  dispatch({ type: RESET_ERRORS });
  const params = { page: 1, pageSize: 10 };
  axios
    .post(`${URL}users/search`, params, {
      headers: {
        "Content-Type": "application/json"
      },
    })
    .then((res) => {
      dispatch({
        type: GET_USERS,
        payload: res.data,
      });
    })
    .catch((err) => {
      disPatchError(err, dispatch);
    });
};
// Gets Users
export const triggerEmail = (token, email) => (dispatch) => {
  const sanitizedEmail = encodeURIComponent(email);
  axios
    .get(`${URL}users/email-reset-password/${sanitizedEmail}`, {
      headers: {
      },
    })
    .then((res) => { })
    .catch((err) => disPatchError(err, dispatch));
};

// Gets Users
export const search = (params) => (dispatch) => {
  dispatch({ type: "TOGGLE_LOAD", payload: true });
  dispatch({ type: RESET_ERRORS });
  axios
    .post(`${URL}users/search`, params, {
      headers: {
        "Content-Type": "application/json"
      },
    })
    .then((res) => {
      dispatch({
        type: GET_USERS,
        payload: res.data,
      });
    })
    .catch((err) => {
      disPatchError(err, dispatch);
    });
};

// Chnages Users Status

// Create User
export const createUser = (userData, token) => (dispatch) => {
  dispatch({ type: "TOGGLE_LOAD", payload: true });
  dispatch({ type: RESET_ERRORS });
  return axios
    .post(`${URL}users`, userData, {
      headers: {
        "Content-Type": "application/json"
      },
    })
    .then((res) => {
      let newUser;
      if (res?.data) {
        newUser = res.data;
      }
      //action to email
      if (newUser?.email) {
        dispatch(triggerEmail(token, newUser.email));
      }

      dispatch({
        type: CREATE_USER,
        payload: newUser,
      });
      trackPendoEvent(TRACK_EVENTS.ADMIN_USER_CREATE, {
        route: window?.location?.pathname,
        source_module: "userManagementActions.createUser",
        access_type: newUser?.accessType,
        role_name: newUser?.userRole?.name || newUser?.userRoleName
      });
      return res;
    })
    .catch((err) => {
      disPatchError(err, dispatch);
      throw err;
    });
};

export const updateUser = (userData) => (dispatch) => {
  dispatch({ type: "TOGGLE_LOAD", payload: true });
  dispatch({ type: RESET_ERRORS });
  return axios
    .patch(`${URL}users`, userData, {
      headers: {
        "Content-Type": "application/json"
      },
    })
    .then((res) => {
      dispatch({
        type: UPDATE_USER,
        payload: res.data,
      });
      trackPendoEvent(TRACK_EVENTS.ADMIN_USER_UPDATE, {
        route: window?.location?.pathname,
        source_module: "userManagementActions.updateUser",
        access_type: res?.data?.accessType,
        role_name: res?.data?.userRole?.name || res?.data?.userRoleName
      });
      return res;
    })
    .catch((err) => {
      disPatchError(err, dispatch);
      throw err;
    });
};
export const updateMultipleUser = (userList) => (dispatch) => {
  dispatch({ type: "TOGGLE_LOAD", payload: true });
  dispatch({ type: RESET_ERRORS });
  return axios
    .patch(`${URL}users/multiple`, userList, {
      headers: {
        "Content-Type": "application/json"
      },
    })
    .then((res) => {
      dispatch({
        type: UPDATE_MULTIPLE_USER,
        payload: res.data,
      });
      trackPendoEvent(TRACK_EVENTS.ADMIN_USER_UPDATE, {
        route: window?.location?.pathname,
        source_module: "userManagementActions.updateMultipleUser",
        role_name: userList?.userRole?.name || userList?.userRoleName
      });
      return res;
    })
    .catch((err) => {
      disPatchError(err, dispatch);
      throw err;
    });
};

export const activateDeactivate = (list, action) => (dispatch) => {
  dispatch({ type: "TOGGLE_LOAD", payload: true });
  dispatch({ type: RESET_ERRORS });
  const sanitizedAction = encodeURIComponent(action);
  axios
    .post(`${URL}${sanitizedAction}`, list, {
      headers: {
        "Content-Type": "application/json"
      },
    })
    .then((res) => {
      dispatch({
        type: ACTIVATE_DEACTIVATE_USER,
        payload: res.data,
      });
      trackPendoEvent(
        sanitizedAction === "activate-users"
          ? TRACK_EVENTS.ADMIN_USER_ACTIVATE
          : TRACK_EVENTS.ADMIN_USER_DEACTIVATE,
        {
          route: window?.location?.pathname,
          source_module: "userManagementActions.activateDeactivate"
        }
      );
    })
    .catch((err) => {
      disPatchError(err, dispatch);
    });
};

// Gets Users
export const getValues = () => (dispatch) => {
  dispatch({ type: "TOGGLE_LOAD" });
  dispatch({ type: RESET_ERRORS });
  axios
    .get(`${URL}create-user-form`, {
      headers: {
      },
    })
    .then((res) => {
      dispatch({
        type: GET_VALUES_USER_CREATE,
        payload: res.data,
      });
    })
    .catch((err) => disPatchError(err, dispatch));
};

export const getAllUsers = () => (dispatch) => {
  dispatch({ type: "TOGGLE_LOAD" });
  dispatch({ type: RESET_ERRORS });
  axios
    .get(`${URL}allUsers`, {
      headers: {
      },
    })
    .then((res) => {
      dispatch({
        type: GET_ALL_USERS,
        payload: res.data,
      });
    })
    .catch((err) => disPatchError(err, dispatch));
};

export const getAllUsersByCLients = () => (dispatch) => {
  dispatch({ type: "TOGGLE_LOAD" });
  dispatch({ type: RESET_ERRORS });
  axios
    .get(`${URL}allUsersByClients`, {
      headers: {
      },
    })
    .then((res) => {
      dispatch({
        type: GET_ALL_USERS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ALL_USERS,
        payload: []
      });
    });
};
